import "react-app-polyfill/ie11";
import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import store from "./store/store";
import { Provider } from "react-redux";
import AppWrapper from "./AppWrapper";
import debounce from "lodash.debounce";
import { saveState } from "./browser-storage";
import i18next from "i18next";
import { I18nextProvider } from "react-i18next";
import { Loading } from "./pages/Loading/Loading";

store.subscribe(
	debounce(() => {
		saveState(store.getState());

	}, 800)
);

i18next.init({
	interpolation: { escapeValue: false },  // React already does escaping
});



ReactDOM.render(
	<Provider store={store}>
		<I18nextProvider i18n={i18next}>
			<Suspense fallback={<div><Loading></Loading></div>}>
				<AppWrapper />
			</Suspense>
		</I18nextProvider>
	</Provider>,
	document.getElementById("root")
);

